import { render, staticRenderFns } from "./CompSalesMetric.vue?vue&type=template&id=4d18411f&scoped=true"
import script from "./CompSalesMetric.vue?vue&type=script&lang=js"
export * from "./CompSalesMetric.vue?vue&type=script&lang=js"
import style0 from "./CompSalesMetric.vue?vue&type=style&index=0&id=4d18411f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d18411f",
  null
  
)

export default component.exports